import {
  FORGOT_PASSOWRD_REQUEST,
  FORGOT_PASSOWRD_SUCCESS,
  FORGOT_PASSOWRD_FAILURE,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
};

const forgotPassword = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case FORGOT_PASSOWRD_REQUEST:
      return { ...state, loading: true };
    case FORGOT_PASSOWRD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case FORGOT_PASSOWRD_FAILURE:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default forgotPassword;
